import { render, staticRenderFns } from "./TQFDetail.vue?vue&type=template&id=52eb5a54&"
import script from "./TQFDetail.vue?vue&type=script&lang=js&"
export * from "./TQFDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports